module.exports = __webpack_public_path__ + "static/media/remoteAuthScoreFileImport.0dd83189.xlsx";